import { render, staticRenderFns } from "./MotivoSolicitacao.vue?vue&type=template&id=157d17e8&"
import script from "./MotivoSolicitacao.vue?vue&type=script&lang=js&"
export * from "./MotivoSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports